<template>
    <div v-if="isLargeScreen">
      <Breadcrumbs main="Overview" title="Overview" />
  
      <div  class="container-fluid">
        <div class="row widget-grid">
          <div class="row d-flex align-items-stretch mb-4">
            <KeyMetrics />
            <Account />
          </div>
          <Transactions />
        </div>
      </div>
    </div>
    <div v-else>
        <MobileOverview />
    </div>    
    <AutoPayPauseModal />
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useDriverStore } from '@/store/driver/driver';
  import KeyMetrics from './keyMetrics';
  import Account from './account';
  import Transactions from './transactions';
  import MobileOverview from './mobile/index.vue'
  import AutoPayPauseModal from '../profile/AutoPayPauseModal.vue';
  
  const isLargeScreen = ref(true);
  
  // 檢查螢幕大小
  function checkScreenSize() {
    isLargeScreen.value = window.innerWidth >= 992;
  }
  
  onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    const driverStore = useDriverStore();
    driverStore.fetchAutoPayPauseModal();
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });
  </script>
